/* * @Author: 曹俊杰 * @Date: 2022-02-24 18:28:42 * @Module: 查看更多 */
<template>
  <div class="hdqSection">
    <div class="left">
      <div class="icon"></div>
      {{ title }}
      <div class="leftSlot">
        <slot name="left"></slot>
      </div>
    </div>
    <div class="more" @click="more">{{ moreText }}</div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    moreText: {
      type: String,
      default: "更多",
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    more() {
      this.$emit("more");
    },
  },
};
</script>
<style lang="scss" scoped>
.hdqSection {
  height: 60px;
  display: flex;
  font-size: 16px;
  font-family: "Noto Sans SC";
  font-weight: 500;
  align-items: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  color: #262626;
  padding-left: 16px;
  padding-right: 16px;
  .left {
    display: flex;
    align-items: center;
    .icon {
      width: 3px;
      height: 16px;
      border-radius: 10px;
      background: #0062ff;

      z-index: 0;
      margin-right: 10px;
    }
  }
  .more {
    font-size: 14px;
    font-family: "Noto Sans SC";
    font-weight: 400;
    color: #666666;
    cursor: pointer;
  }
  .leftSlot{
    margin-left: 9px;
  }
}
</style>
